module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10271.465f4fa9.jpg";